<template>
  <div class="home">
    <div class="head-title">用户列表</div>
    <div class="">
      <div class="">
        <div class="">
          <nav class="">
            <!-- 地区 -->
            <div class="">
              <el-cascader
                style="margin-right: 24px; width: 24.0rem"
                :options="options"
                clearable
                v-model="selectedOptions"
                @change="handleChang"
              ></el-cascader>
              <el-input
                style="margin-right: 24px; width: 28.0rem"
                clearable
                v-model="czphone"
                placeholder="手机号查询"
                @change="getUserAccount"
              >
                <el-button type="primary" slot="append" @click="getUserAccount"
                  >查询</el-button
                >
              </el-input>
              <el-select
                clearable
                v-model="value"
                style="
                  margin-right: 24px;
                  width: 24.0rem;
                  display: inline-flex;
                  min-width: auto;
                "
                placeholder="请选择分配状态"
                @change="getUserAccount"
              >
                <el-option
                  v-for="item in zpoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button type="primary" @click="zhiyuanfenpei()"
                >资源分配</el-button
              >
              <el-select
                  clearable
                  v-model="timeValue"
                  style="
                  margin-left: 24px;
                  width: 24.0rem;
                  display: inline-flex;
                  min-width: auto;
                "
                  placeholder="请选择过期状态"
                  @change="getUserAccount"
              >
                <el-option
                    v-for="item in tiemOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
              <el-button style="margin-left: 24px" type="primary"  class="export" plain @click="exportExcel"><i class="el-icon-download"></i>导出</el-button>
            </div>
          </nav>
          <el-table
            :data="tableData.data"
            id="educe-table"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            width="100%"
            
            border
            style="margin-top: 2.0rem"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号"
              style="width: 30%"
            ></el-table-column>
            <el-table-column
              prop="account_name"
              label="企业名称"
              show-overflow-tooltip
              style="width: 30%"
            ></el-table-column>
            <el-table-column
              prop="agent_account"
              label="归属代理商"
              show-overflow-tooltip
              style="width: 30%"
            ></el-table-column>
            <el-table-column
              prop="province"
              label="省"
              style="width: 10%"
            ></el-table-column>
            <el-table-column
              prop="city"
              label="城市"
              style="width: 10%"
            ></el-table-column>
            <el-table-column
              prop="if_allocation"
              label="分配情况"
              style="width: 10%"
            >
              <template slot-scope="scope">
                <div :class="scope.row.if_allocation === 1 ? 'red' : 'blue'">
                  {{ transignificance(scope.row.if_allocation, newList) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="if_end" label="是否过期" style="width: 40%">
              <template slot-scope="scope">
                <div
                  :class="{
                    danger: scope.row.if_end === '已过期',
                  }"
                >
                  {{ scope.row.if_end }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="addtime"
              label="注册时间"
              show-overflow-tooltip
              style="width: 40%"
            ></el-table-column>
            <el-table-column prop="user_pasttime" show-overflow-tooltip label="过期时间">
            </el-table-column>
            <el-table-column
              prop="priveName"
              label="权限名称"
              style="width: 40%"
            ></el-table-column>
          </el-table>
          <div class="paging">
            <pagination
              :total="tableData.total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              :page-sizes="[10,20,50,100]"
              @pagination="getUserAccount"
            />
          </div>
          <el-dialog title="控制" center :visible.sync="onSubmits" width="30%">
            <div>
              <span class="button" :class="nba ? 'buttoom' : ''" @click="crm"
                >CRM</span
              >
              <span
                class="button"
                :class="nba ? '' : 'buttoom'"
                @click="session"
                >会话存档</span
              >
            </div>
            <div style="margin-top: 3.0rem" v-if="nba">
              人数监管：
              <el-input
                clearable
                v-model="input"
                type="number"
                placeholder="请输入内容"
                style="display: inline-block; width: 50%"
              ></el-input>
            </div>
            <div style="margin-top: 3.0rem" v-if="!nba">
              人数监管：
              <el-input
                clearable
                v-model="input2"
                type="number"
                placeholder="请输入内容"
                style="display: inline-block; width: 50%"
              ></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="onSubmits = false">取 消</el-button>
              <el-button type="primary" @click="numoo()">确 定</el-button>
            </span>
          </el-dialog>
          <el-dialog title="添加" center :visible.sync="onSubmitsc" width="25%">
            <el-form
              :rules="rules"
              ref="forms"
              :model="forms"
              label-width="13.0rem"
            >
              <el-form-item label="手机号" prop="phone">
                <el-input clearable v-model="forms.phone"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="password">
                <el-input
                  clearable
                  v-model="forms.password"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item
                label="确认密码"
                prop="passwordadd"
                @blur="inputtel()"
              >
                <el-input
                  clearable
                  v-model="forms.passwordadd"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item label="市区选择">
                <el-cascader
                  size="large"
                  :options="hadd"
                  v-model="hahha"
                  @change="handleChange"
                ></el-cascader>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="onSubmitsc = false">取 消</el-button>
              <el-button type="primary" @click="submitForm('forms')"
                >确 定</el-button
              >
            </span>
          </el-dialog>
          <el-dialog title="资源分配" center :visible.sync="onSubmitscss" width="60%">
            <el-form ref="formMf" :model="formse" label-width="8.0rem">
              <el-form-item label="筛选" style="display: inline-block">
                <!-- 地区 -->
                <el-cascader
                  clearable
                  size="large"
                  :options="options"
                  v-model="selectedOptionson"
                  @change="handleChangss"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="账号" style="display: inline-block">
                <el-input
                  clearable
                  v-model="formse.accounti"
                  placeholder="账号查询"
                  @change="getAgentUser"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号" style="display: inline-block">
                <el-input
                  clearable
                  v-model="formse.czphone"
                  placeholder="手机号查询"
                  @change="getAgentUser"
                ></el-input>
              </el-form-item>

              <el-form-item style="display: inline-block">
                <el-button
                  type="primary"
                  style="position: relative; right: 4.0rem"
                  @click="getAgentUser"
                  >搜索</el-button
                >
              </el-form-item>
            </el-form>
            <el-table
              :data="getAgentUsers.data"
              row-key="id"
              style="width: 100%"
              border
              highlight-current-row
              @current-change="handleCurrentChangess"
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            >
              <el-table-column
                prop="account"
                label="账号"
                style="width: 20.0rem"
              ></el-table-column>
              <el-table-column
                prop="phone"
                label="手机号"
                style="width: 10.0rem"
              ></el-table-column>
              <el-table-column
                prop="province"
                label="省"
                style="width: 10.0rem"
              ></el-table-column>
              <el-table-column
                prop="city"
                label="城市"
                style="width: 10.0rem"
              ></el-table-column>
              <el-table-column
                prop="enterpriseName"
                label="营业名称"
                style="width: 10.0rem"
              ></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
              <el-button @click="onSubmitscss = false">取 消</el-button>
              <el-button type="primary" @click="overfoike()">确 定</el-button>
            </span>
            <pagination
              :total="getAgentUsers.total"
              :page.sync="getList.page"
              :limit.sync="getList.limit"
              :page-sizes="[10,20,50,100]"
              @pagination="getAgentUser"
            />
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import FileSaver from 'file-saver';
import * as XLSX from "xlsx"
import qs from "qs";
import { provinceAndCityData, CodeToText } from "element-china-area-data";
import md5 from "js-md5";
export default {
  data() {
    return {
      onSubmits: false,
      onSubmitsc: false,
      nba: true,
      tableData: {
        total: 0,
        data: [],
      },
      url: "https://api.weijub.com",
      newList: { 1: "未分配", 2: "已分配" },
      tooken: "",
      title: {},
      //  地址
      options: [],
      selectedOptions: [],
      formfp: {
        province: "",
        city: "",
      },
      form: {
        province: "",
        city: "",
      },
      czphone: "",
      zpoptions: [
        {
          value: "1",
          label: "未分配",
        },
        {
          value: "2",
          label: "已分配",
        },
      ],
      //过期状态选择数据
      tiemOptions:[
        {
          value: "1",
          label: "未过期",
        },
        {
          value: "2",
          label: "已过期",
        },
      ],
      timeValue:'',
      value: "",
      input: "",
      input2: "",
      id: "",
      type: "crm",
      forms: {
        phone: "",
        password: "",
        passwordadd: "",
        province: "",
        city: "",
      },
      page: "1",
      // 地址
      hadd: provinceAndCityData,
      hahha: [],
      onSubmitscss: false,
      getAgentUsers: {
        total: 0,
        data: [],
      },
      valid: [],
      agent_id: {},
      selectedOptionson: [],
      formse: {
        province: "",
        city: "",
        accounti: "",
        czphone: "",
      },
      rules: {
        //手机
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          { min: 11, max: 30, message: "手机格式不正确", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          {
            min: 6,
            max: 30,
            message: "长度在 6 到 30 个字符",
            trigger: "blur",
          },
        ],
        passwordadd: [
          { required: true, message: "密码必须一致", trigger: "blur" },
          { min: 6, max: 30, message: "密码必须一致", trigger: "blur" },
        ],
      },
      listQuery: {
        page: 1,
        limit: 20,
      },
      getList: {
        page: 1,
        limit: 20
      }
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("title")) {
      let title = JSON.parse(window.sessionStorage.getItem("title"));
      this.title = title;
      var a = document.title;
      document.title = title[0].website + "-" + a;
    }
    if (window.sessionStorage.getItem("userinfone")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfone"));
      this.tooken = userinfo;
    }
    this.getUserAccount();
    this.getAreaTreeList();
    this.getAgentUser();
  },
  methods: {
    getAgentUser() {
      this.axios
        .post(
          "/api/agent/getAgentUser",
          qs.stringify({
            account: this.formse.accounti,
            province: this.formse.province,
            city: this.formse.city,
            totaltoken: this.tooken.totaltoken,
            phone: this.formse.czphone,
            page:this.getList.page,
            number_page:this.getList.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.getAgentUsers = res.data.data;
        })
        .catch(function (err) {});
    },
    overfoike() {
      let aa = [];
      this.valid.forEach((item) => {
        aa.push(item.id);
      });
      aa = aa.toString(aa);
      this.axios
        .post(
          "/api/agent/agentAccount",
          qs.stringify({
            agent_id: this.agent_id.id, //代理商id
            user_account_id: aa, //用户列表id 逗号隔开 字符串
            totaltoken: this.tooken.totaltoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          if (res.data.code == 1) {
            this.zhiyuan = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.zhiyuan = true;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    handleCurrentChangess(val) {
      this.agent_id = val;
    },
    zhiyuanfenpei() {
      if (this.valid == 0) {
        this.$message.error("请至少选择一名用户");
      } else {
        this.onSubmitscss = true;
      }
    },
    handleSelectionChange(val) {
      this.valid = val;
    },
    getAreaTreeList() {
      this.axios
        .post("/api/Area/getAreaTreeList", qs.stringify({}), {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then((res) => {
          // console.log(res);
          this.options = res.data.data;
        })
        .catch(function (err) {});
    },
    inputtel() {
      if (this.forms.passwordadd !== this.forms.password) {
        this.$message.error("请与密码保持一致");
        return;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.forms.passwordadd !== this.forms.password) {
            this.$message.error("请与密码保持一致");
            return;
          } else {
            this.axios
              .post(
                "/api/user/register",
                qs.stringify({
                  totaltoken: this.tooken.totaltoken,
                  password: this.$md5(this.forms.password),
                  phone: this.forms.phone,
                  province: this.forms.province,
                  city: this.forms.city,
                }),
                {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                  },
                }
              )
              .then((res) => {
                if (res.data.code == 1) {
                  this.onSubmitsc = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.getUserAccount();
                } else if (res.data.code == 0) {
                  this.onSubmitsc = true;
                  this.$message.error(res.data.msg);
                }
              })
              .catch(function (err) {});
          }
        } else {
          return false;
        }
      });
    },
    handleChange(value) {
      //赋值省
      this.forms.province = CodeToText[value[0]];
      //赋值市
      this.forms.city = CodeToText[value[1]];
    },
    handleChangss(value) {
      //赋值省
      this.formse.province = value[0];
      //赋值市
      this.formse.city = value[1];
      this.getAgentUser();
    },
    numoo() {
      let type;
      let count;
      if (this.nba) {
        type = "crm";
        count = this.input;
      }
      if (!this.nba) {
        type = "session";
        count = this.input2;
      }
      this.axios
        .post(
          "/api/index/assignUser",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            id: this.id,
            type,
            count,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmits = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getUserAccount();
          } else if (res.data.code == 0) {
            this.onSubmits = true;
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    crm() {
      this.nba = true;
      this.type = "crm";
      this.axios
        .post(
          "/api/index/getAssignUser",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            id: this.id,
            type: this.type,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.input = res.data.data.count;
        })
        .catch(function (err) {});
    },
    session() {
      this.nba = false;
      this.type = "session";
      this.axios
        .post(
          "/api/index/getAssignUser",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            id: this.id,
            type: this.type,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.input2 = res.data.data.count;
        })
        .catch(function (err) {});
    },
    onDetail(a) {
      this.id = a;
      this.axios
        .post(
          "/api/index/getAssignUser",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            id: this.id,
            type: this.type,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.input = res.data.data.count;
          this.input2 = res.data.data.count;
        })
        .catch(function (err) {});
    },
    getUserAccount() {
      this.axios
        .post(
          "/api/index/getUserAccount",
          qs.stringify({
            province: this.formfp.province,
            city: this.formfp.city,
            totaltoken: this.tooken.totaltoken,
            phone: this.czphone,
            page: this.page,
            if_allocation: this.value,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            if_past:this.timeValue
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },

    // 省市筛选
    handleChang(value) {
      //赋值省
      this.formfp.province = value[0];
      //赋值市
      this.formfp.city = value[1];
      this.getUserAccount();
    },
    // 提交过后输出的数据\
    transignificance(val, type) {
      for (const key in type) {
        if (key * 1 === val) {
          return type[key];
        }
      }
    },
    //表格导出
    exportExcel() {
      // 1.生成Excel工作簿对象
      var wb = XLSX.utils.table_to_book(document.querySelector('#educe-table'))
        wb.Sheets.Sheet1['!cols'][0]={hidden:true}
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        book: true,
        type: 'array'
      })
      try {
        FileSaver.saveAs(
            // Blob: 对象表示一个不可变 原始数据的类文件对象,不一定是JS原生格式的数据。
            // File: 基于Blob，继承了blob的功能并将其扩展使其支持用户系统上的文件。
            new Blob([wbout], { type: 'appliction/octet-stream' }),
            // 设置导出的文件名称可随意
            '请编辑表格名.xls'
        )
      } catch (e) {
        if (typeof console != 'undefined') console.log(e, wbout)
      }
      // 返回一个新创建的Blob对象，其内容由参数中给定的数组串联组成。
      return wbout
    }
  },
  // 1.用户分配
};
</script>
<style  lang="scss" scoped>
::v-deep .el-table__body tr.current-row > td {
  background-color: rgb(185, 234, 250);
}
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgb(185, 234, 250);
}
::v-deep
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped.current-row
  td {
  background-color: rgb(185, 234, 250);
}
</style>
<style scoped>
.red {
  color: blue;
}
.blue {
  color: #f56c6c;
}
.home {
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0,0,0,0.1);
}
.body_html {
  width: 100%;
  height: 100%;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem 1px 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 23px 31px;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia > main {
  font-size: 26px;
}
.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
.el-form-item {
  display: inline-block;
}
.button {
  padding: 15px;
  color: black;
  background-color: #ffffff;
  cursor: pointer;
  border: 1px solid #dcdfe6;
}
.buttoom {
  background: rgb(64, 158, 255);
  color: #ffffff;
}
.danger {
  color: #f56c6c;
}
</style>
